import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './Authorization/AuthContext';
import ProjectSelector from './Authorization/ProjectSelector';

const Home: React.FC = () => {
  const { user, msalAccount, selectedProject, isProjectSelectionRequired } = useAuth();
  const navigate = useNavigate();

  // Auto-navigate to data_review when project is selected
  useEffect(() => {
    if (selectedProject && !isProjectSelectionRequired) {
      navigate('/data_review');
    }
  }, [selectedProject, isProjectSelectionRequired, navigate]);

  // If project selection is required, show the project selector
  if (isProjectSelectionRequired || !selectedProject) {
    return <ProjectSelector />;
  }

  const displayName = user?.profile?.name || user?.profile?.email
    || msalAccount?.name || msalAccount?.username || 'User';

  // Otherwise show a loading state while navigating
  return (
    <Container>
      <Title>Welcome {displayName}</Title>
      <Message>Loading...</Message>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
  color: #333;
`;

const Message = styled.p`
  font-size: 18px;
  color: #666;
  text-align: center;
`;

export default Home;